<template>
  <div>
    <ShareModal
      :itemId="1"
      :item-url="songUrl"
      :name="songs[audio_index].title"
    />
    <div class="album-header" style="margin-top: 80px">
      <img class="album-header__image" :src="albumImage" alt="album image" />
      <div class="album-header__info">
        <h1 class="album-header__info__title">{{ album.title }}</h1>
        <div class="album-header__info__details">
          <div class="album-header__info__details__item">
            <img
              class="album-header__info__details__item__img"
              :src="artistImage"
            />
            <div class="album-header__info__details__item__value">
              {{ album?.creator?.name?album?.creator.name:album?.name }} -
              {{ new Date(album.created_at).getFullYear() }} -
              {{ songs.length }} songs
            </div>
          </div>
          <div class="album-header__info__details__item_genres">
            <span
                class="album-header__info__details__item__genres__value"
                v-for="genre in album?.genres"
            >{{ genre?.name??'' }}</span
            >
            <slot name="playlist">
            </slot>
          </div>
        </div>
        
      </div>
    </div>
    <div
      class="simple-audio-player"
      id="simp"
      data-config='{"shide_top":false,"shide_btm":false,"auto_load":false}'
    >
      <div class="simp-playlist">
        <ul style="max-heig,ht: unset">
          <li
            v-for="(song, index) in songs"
            :class="{ 'simp-active': audio_index == index }"
            @click="audio_index = index"
            style="position: relative"
          >
            <span class="simp-source">{{ index + 1 }}. {{ song.title }}</span>
            <span class="simp-desc">{{ album?.creator?.name?album?.creator?.name:song?.item?.creator?.name }}</span>

            <slot name="add-to-playlist"></slot>
          </li>
        </ul>
        <!-- three dots for more options -->

      </div>
    </div>
    <div
      id="player-wrapper"
      :class="{ 'top-4': !hide_player }"
      :data-show-list="show_list ? 'true' : 'false'"
      :data-show-info="show_info ? 'true' : 'false'"
    >
      <div
        id="ripple-effect-list"
        :class="{ active: show_list == true }"
        v-if="!hide_player"
      ></div>

      <div class="toolbar" v-if="!hide_player">
        <div
          id="close"
          :class="{ show: show_list == true }"
          @click="show_list = false"
        >
          <i class="fas fa-times"></i>
        </div>

        <div
          class="list-icon"
          @click="show_list = !show_list"
          v-if="show_list == false && show_info == false"
        >
          <i class="fas fa-stream"></i>
        </div>
        <div class="toggle-icon" @click="hidePlayer" v-if="show_list == false">
          <i class="fas fa-chevron-down"></i>
        </div>
      </div>

      <div
        class="playlist-container"
        :class="{ 'top-10': show_list }"
        v-if="!hide_player"
      >
        <div class="list-container">
          <div
            class="list-item"
            v-if="show_list"
            v-for="(c, i) in songs"
            @click="audio_index = i"
            :class="{ active: audio_index == i }"
          >
            <div class="loading" v-if="is_loading == true"></div>
            <div class="title">{{ c.title }}</div>
            <div class="meta">
              <span class="">{{ album.creator?.name?album.creator?.name:c.item.creator.name }}</span>
              <!--              <span class=''>123</span>-->
            </div>
          </div>
        </div>
      </div>

      <div
        class="player-container"
        :style="{ 'padding-top': hide_player ? '0.5em' : '1.5em' }"
      >
        <div class="title-container" v-if="!hide_player">
          <div class="title">{{ album.title }}</div>
          <div class="author">{{ album.creator?.name??'' }}</div>
        </div>
        <div class="cover-wrapper" v-if="!hide_player">
          <spectrum
            :pins="normlizeAudioPins"
            v-on:avarage="updateAvarage($event)"
          ></spectrum>

          <div class="cover" :style="coverArtTransition">
            <img :src="songs[audio_index].cover" />
          </div>
        </div>
        <div class="chapter" v-if="!hide_player">
          {{ songs[audio_index].title }}
        </div>
        <div class="audio-bar-wrapper">
          <div class="audio-bar-container" @mousedown="barClick">
            <div class="bar" ref="bar">
              <span class="loading" v-if="is_loading == true"></span>
              <span class="played" :style="{ width: handlePosition }"></span>
              <span
                class="buffered"
                v-for="b in buffered"
                :style="{ left: b.left, width: b.width }"
              ></span>
            </div>
            <div
              class="handle"
              id="handle"
              :style="{ left: handlePosition }"
            ></div>
          </div>
          <div class="time-container">
            <div class="current">{{ currentTime }}</div>
            <div class="end">{{ endTime }}</div>
          </div>
        </div>
        <div class="controls">
          <img
            v-if="hide_player"
            :src="songs[audio_index].cover"
            @click="hidePlayer"
            alt=""
          />

          <!--          Like-->
          <div class="like" @click="likeSong">
            <i class="material-icons" v-if="!songs[audio_index].isLiked"
              >favorite_border</i
            >
            <i
              class="material-icons text-danger"
              v-if="songs[audio_index].isLiked"
              >favorite</i
            >
          </div>
          <div
            class="prev"
            :class="{ disabled: !shuffle && audio_index <= 0 }"
            @click="playPrev"
          >
            <i class="fas fa-backward"></i>
          </div>
          <div class="play-pause" @click="playAudio()">
            <i class="fas fa-play" v-if="is_playing == false"></i>
            <i class="fas fa-pause" v-if="is_playing == true"></i>
          </div>
          <div
            class="next"
            :class="{ disabled: !shuffle && audio_index >= songs.length - 1 }"
            @click="playNext"
          >
            <i class="fas fa-forward"></i>
          </div>
          <!--          share -->
          <div class="share" @click="shareSong">
            <i class="material-icons">share</i>
          </div>
        </div>
        <div class="options" v-if="!hide_player">
          <div
            class="shuffle"
            @click="shuffle = !shuffle"
            :class="{ active: shuffle == true }"
          >
            <i class="material-icons">shuffle</i>
          </div>
          <div class="speed" @click="toggleSpeed">{{ speed }}x</div>
          <div
            class="repeat"
            @click="changeRepeat"
            :class="{ active: repeat || repeat_all }"
          >
            <i class="material-icons">repeat</i>
            <span v-if="repeat && !repeat_all">1</span>
          </div>
          <div
            class="auto-playlist"
            @click="list_play = !list_play"
            :class="{ active: list_play == true }"
          >
            <i class="material-icons">playlist_play</i>
          </div>
        </div>
      </div>

      <div id="error-box" :class="{ show: is_error == true }">
        {{ this.error_msg }}
      </div>
    </div>
  </div>
</template>

<script>
import Spectrum from "./spectrum.vue";
import axios from "axios";
import ShareModal from "../../creator/components/share-modal.vue";

export default {
  name: "album",
  components: { ShareModal, Spectrum },
  props: [
    "album",
    "songsList",
    "albumImage",
    "artistImage",
    "isAuth",
    "selectedSong",
  ],
  data() {
    return {
      hide_player: true,
      songs: [],
      handle_clicked: false,
      handle_position: 0,
      bar: null,
      is_playing: false,
      is_loading: true,
      is_error: false,
      error_timeout: null,
      error_msg: "",
      audio_obj: null,
      audio_index: 0,
      duration: 0,
      current_time: 0,
      audio_pins: [],
      analyser: null,
      data_array: [],
      buffered: [],
      speed: 1,
      repeat: false,
      repeat_all: false,
      repeat_count: 0,
      list_play: true,
      show_list: false,
      show_info: false,
      cover_art_avarage: 0,
      shuffle: false,
      liked: false,
    };
  },

  created() {
    for (let i = 0; i < this.songsList.length; i++) {
      this.songs[i] = this.songsList[i];
      this.songs[i].isLiked = this.songsList[i].isLiked == 1 ? true : false;
    }
    if (this.selectedSong != null && this.selectedSong !== 0)
    this.audio_index = Number(this.selectedSong) - 1;
  },
  mounted: function () {
    this.bar = this.$refs.bar.getBoundingClientRect();
    let handle = this.$refs.handle;
    


    document.addEventListener("mousedown", this.mouseDown);
    document.addEventListener("mouseup", (e) => (this.handle_click = false));
    document.addEventListener("mousemove", this.moveHandler);

    window.addEventListener("resize", this.resizeHandler);

    // initiate audio obj
    this.audio_obj = new Audio(this.songs[this.audio_index].link);
    this.audio_obj.crossOrigin = "anonymous";
    this.audio_obj.src = this.songs[this.audio_index].link;
    this.audio_obj.load();

    this.audio_obj.addEventListener("loadeddata", () => {
      this.duration = this.audio_obj.duration;
    });

    this.audio_obj.addEventListener("ended", this.onEnded);
    this.audio_obj.addEventListener("progress", this.onProgress);
    this.audio_obj.addEventListener("loadedmetadata", this.onProgress);
    this.audio_obj.addEventListener("playing", (e) => (this.is_playing = true));
    this.audio_obj.addEventListener("pause", (e) => (this.is_playing = false));
    this.audio_obj.addEventListener(
      "canplay",
      (e) => (this.is_loading = false)
    );
    this.audio_obj.addEventListener("seeking", (e) => (this.is_loading = true));
    this.audio_obj.onerror = this.onError;
  },
  methods: {
    changeRepeat() {
      if (this.repeat) {
        this.repeat = false;
        this.repeat_all = true;
      } else if (this.repeat_all) {
        this.repeat_all = false;
      } else {
        this.repeat = true;
      }
    },


    sharePopup() {
      $(`#shareModal${1}`).modal("show");
    },
    shareSong() {
      this.sharePopup();
    },
    hidePlayer() {
      this.hide_player = !this.hide_player;
      
      if (!this.hide_player) {
        document.querySelector("body").style.overflowY = "hidden";
      } else {
        document.querySelector("body").style.overflowY = "auto";
      }
    },
    onError: function () {
      let msg = this.audio_obj.error.code + `: ` + this.audio_obj.error.message;
      console.error("ERROR", msg);
      this.is_error = true;
      this.error_msg = msg;

      this.is_playing = false;
      this.is_loading = false;

      clearTimeout(this.error_timeout);
      this.error_timeout = setTimeout(() => {
        this.is_error = false;
        this.error_msg = "";
      }, 3500);
    },
    onEnded: function (event) {
      this.audio_obj.currentTime = 0;
      if (this.repeat && !this.repeat_all && this.repeat_count < 1) {
        this.audio_obj.play();
        this.repeat_count = this.repeat_count + 1;
        return;
      }

      if (this.repeat_all) {
        const newIndex = this.audio_index + 1;
        if (newIndex < this.songs.length) {
          this.audio_index = newIndex;
          return;
        }
        this.audio_index = 0;
        return;
      }

      if (this.repeat_count == 1) {
        this.repeat_count = 0;
      }
      if (this.list_play && this.shuffle) {
        const newIndex = Math.floor(Math.random() * this.songs.length);
        this.audio_index = newIndex;
        return;
      }
      if (this.list_play) {
        const newIndex = this.audio_index + 1;
        if (newIndex < this.songs.length) this.audio_index = newIndex;
        return;
      }

      this.is_playing = false;
      this.repeat = false;
    },
    onProgress: function (e) {
      const oneSecond = 100 / this.duration;
      const ranges = [];
      for (var i = 0; i < this.audio_obj.buffered.length; i++) {
        const start = this.audio_obj.buffered.start(i);
        const end = this.audio_obj.buffered.end(i);

        const position = {};
        position.left = oneSecond * start + "%";
        position.width = oneSecond * (end - start) + "%";

        ranges.push(position);
      }

      this.buffered = ranges;
    },
    updateAvarage: function (event) {
      this.cover_art_avarage = event;
    },
    timeUpdated: function () {
      this.current_time = this.audio_obj.currentTime;
      this.analyser.getByteTimeDomainData(this.data_array);
      this.audio_pins = Array.from(this.data_array);

      requestAnimationFrame(this.timeUpdated);
    },
    likeSong: async function () {
      try {
        this.$Progress.start();
        await axios.post(`/song/${this.songs[this.audio_index].id}/like`);
        let songs = [...this.songs];
        songs[this.audio_index].isLiked = !songs[this.audio_index].isLiked;
        this.songs = songs;
        // this.songs = songs
        this.$Progress.finish();
      } catch (e) {
        this.$Progress.fail();
        notify("error", "Something went wrong");
      }
    },
    playNext: function () {
      if (this.shuffle) {
        this.audio_index = Math.floor(Math.random() * this.songs.length);
        return;
      }
      const newIndex = this.audio_index + 1;

      if (newIndex >= this.songs.length) return;

      this.audio_index = newIndex;
    },
    playPrev: function () {
      // when in shuffle
      if (this.shuffle) {
        this.audio_index = Math.floor(Math.random() * this.songs.length);
        return;
      }
      const newIndex = this.audio_index - 1;

      if (newIndex < 0) return;
      this.audio_index = newIndex;
    },
    initAnalyser: function () {
      const ctx = new AudioContext();
      this.analyser = ctx.createAnalyser();
      const audioSrc = ctx.createMediaElementSource(this.audio_obj);

      // we could configure the analyser: e.g. analyser.fftSize (for further infos read the spec)
      // 256
      this.analyser.minDecibels = -90;
      this.analyser.maxDecibels = -10;
      this.analyser.smoothingTimeConstant = 0.75;
      this.analyser.fftSize = 128;

      // we have to connect the MediaElementSource with the analyser
      audioSrc.connect(this.analyser);
      this.analyser.connect(ctx.destination);

      const bufferLength = this.analyser.frequencyBinCount;
      this.data_array = new Uint8Array(bufferLength);
    },
    playAudio: function () {
      if (this.is_playing) this.audio_obj.pause();
      else this.audio_obj.play();

      if (this.analyser == null) {
        this.initAnalyser();
        requestAnimationFrame(this.timeUpdated);
      }
    },
    toggleSpeed: function () {
      const speedArray = [
        "0.25",
        "0.5",
        "0.75",
        "1",
        "1.25",
        "1.5",
        "1.75",
        "2",
      ];
      const curerntIndex = speedArray.indexOf(this.speed.toString());
      let newIndex = curerntIndex + 1;

      if (newIndex > speedArray.length - 1) newIndex = 0;

      this.speed = parseFloat(speedArray[newIndex]);
      this.audio_obj.playbackRate = this.speed;
    },
    barClick: function (e) {
      const clickPos = e.clientX - this.bar.x;
      const time = (clickPos * this.duration) / this.bar.width;
      this.audio_obj.currentTime = time;
      this.handle_click = true;
    },
    mouseDown: function (e) {
      if (e.target.id == "handle") this.handle_click = true;
    },
    resizeHandler: function () {
      this.bar = this.$refs.bar.getBoundingClientRect();
    },
    formatSeconds: function (secs) {
      var hr = Math.floor(secs / 3600);
      var min = Math.floor((secs - hr * 3600) / 60);
      var sec = Math.floor(secs - hr * 3600 - min * 60);

      if (min < 10) {
        min = "0" + min;
      }
      if (sec < 10) {
        sec = "0" + sec;
      }

      return min + ":" + sec;
    },
    moveHandler: function (e) {
      let barWidth = this.bar.width;
      let barLeft = this.bar.x;
      let barRight = this.bar.right;

      if (this.handle_click) {
        let left = e.clientX - barLeft;
        if (left < 0) left = 0;

        if (left > barWidth) left = barWidth;

        this.current_time = (left * this.duration) / barWidth;
        this.audio_obj.currentTime = this.current_time;
      }
    },
    moveAudio: function (direction, amount) {
      let newTime = this.current_time;
      amount = parseInt(amount);

      switch (direction) {
        case "increase":
          newTime = newTime + amount;
          break;
        case "decrease":
          newTime = newTime - amount;
          break;
      }

      if (newTime > this.duration || newTime < 0) newTime = this.current_time;

      this.audio_obj.currentTime = newTime;
    },
    updateAudio: function (index) {},
  },
  computed: {
    songUrl: function () {
      return `${window.location.origin}/album/${this.album.id}?song=${
        this.songs[this.audio_index].id
      }`;
    },
    endTime: function () {
      return this.formatSeconds(this.duration);
    },
    currentTime: function () {
      return this.formatSeconds(this.current_time);
    },
    handlePosition: function () {
      return (this.current_time * 100) / this.duration + "%";
    },
    leftTime: function () {
      return this.duration - this.current_time;
    },
    maxAudioPin: function () {
      return this.audio_pins
        .slice()
        .sort((a, b) => b - a)
        .slice(0, 1);
    },
    normlizeAudioPins: function () {
      // 20 is the max length
      return this.audio_pins.map((p) => {
        return (p * 20) / this.maxAudioPin;
      });
    },

    coverArtTransition: function () {
      let scale = (this.cover_art_avarage * 100) / 20 / 100;
      if (scale < 0.98) scale = 0.98;

      return {
        transform: `scale(${scale})`,
      };
    },
    currentLink: function () {
      this.audio_obj.src = this.songs[this.audio_index].link;
    },
  },
  watch: {
    audio_index: function (newIndex, oldVal) {
      this.audio_obj.src = this.songs[newIndex].link;
      this.audio_obj.play();
      this.is_loading = true;
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400&display=swap");
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.0-2/css/all.min.css");
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");

* {
  box-sizing: border-box;

  &::after,
  &::before {
    box-sizing: border-box;
  }
}

$bg-color: hsl(210, 30%, 13%);

:root {
  --bg-hue: 210; //53
  --bg-color: linear-gradient(
    to top,
    hsl(var(--bg-hue), 20%, 18%),
    hsl(var(--bg-hue), 30%, 13%)
  );
  --text-color: hsl(var(--bg-hue), 0%, 70%);
  --hover-bg: rgba(255, 255, 255, 0.1);
  --audio-bar-bg: hsl(calc(var(--bg-hue) - 10), 50%, 10%);
  --audio-bar-played-bg: hsl(calc(var(--bg-hue) - 10), 30%, 40%);
  --audio-bar-buffered-bg: hsl(calc(var(--bg-hue) - 10), 30%, 30%);
  --audio-bar-loading-bg: rgba(255, 255, 255, 0.3);
  --audio-handle-bg: #{lighten($bg-color, 30%)};
  --spectrum-color: hsl(calc(var(--bg-hue) + 10), 15%, 35%);
  --active-color: hsl(calc(var(--bg-hue) - 50), 50%, 70%);
  --active-bg: hsl(calc(var(--bg-hue) + 10), 20%, 30%);

  --scrollbar-foreground: hsl(calc(var(--bg-hue)), 20%, 30%);
  --scrollbar-background: transparent;
}

html {
  font-size: 80.5%;
  user-select: none;
}

body {
  height: 100%;
  width: 100%;
  font-family: "Roboto", "Arial", sans-serif;
}

@mixin scrollbars(
  $size: 4px,
  $foreground-color: var(--scrollbar-foreground),
  $background-color: var(--scrollbar-background)
) {
  // For Google Chrome
  &::-webkit-scrollbar {
    width: $size;
    height: $size;
  }

  &::-webkit-scrollbar-thumb {
    background: $foreground-color;
    border-radius: 0.3rem;
  }

  &::-webkit-scrollbar-track {
    background: $background-color;
  }

  // For Internet Explorer
  & {
    scrollbar-face-color: $foreground-color;
    scrollbar-track-color: $background-color;
    // firefox
    scrollbar-width: thin;
    scrollbar-color: $foreground-color $background-color;
  }
}

.top-4 {
  top: 0rem !important;
  padding-top: 5rem;
}

.top-10 {
  top: 3.2rem !important;
}

#ripple-effect-list,
#ripple-effect-info {
  position: absolute;
  top: 2%;
  right: 4%;
  height: 4em;
  width: 4em;
  background: var(--bg-color);
  border-radius: 50%;
  transition: all 0.3s ease-in-out;
  z-index: 6;
  transition-delay: 0.2s;
  transform: scale(0);

  &.active {
    transform: scale(30);
  }
}

#ripple-effect-info {
  left: 4%;
}

#player-wrapper {
  //border-radius: 2rem;
  //width: 25rem;
  position: fixed;
  width: 100%;
  //z-index: 99999999;
  z-index: 10;
  left: 0;
  right: 0;
  bottom: 0;
  //top: 50%;
  //left: 50%;
  //transform: translate(-50%, -50%);
  box-shadow: 1px 1px 10px 2px rgba(0, 0, 0, 0.2);
  background: var(--bg-color);
  overflow-y: scroll;
  overflow-x: hidden;

  &[data-show-list="true"] {
    #ripple-effect-list {
      transition-delay: 0s;
    }

    .playlist-container {
      pointer-events: initial;

      .list-container {
        opacity: 1;
        transition-delay: 0.35s;
      }
    }
  }

  &[data-show-info="true"] {
    #ripple-effect-info {
      transition-delay: 0s;
    }

    .info-container {
      pointer-events: initial;

      .info-wrapper {
        opacity: 1;
        transition-delay: 0.35s;
      }
    }
  }

  .toolbar {
    .list-icon,
    .toggle-icon {
      font-size: 1.3rem;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 0.1em;
      position: absolute;
      top: 11%;
      right: 4%;
      color: var(--text-color);
      z-index: 8;
    }

    #close {
      font-size: 1.5rem;
      position: absolute;
      top: -2%;
      left: 50%;
      color: var(--text-color);
      z-index: 8;
      transform: translate(-50%, -100%);
      transition: all 0.3s;

      &.show {
        transform: translate(-50%, 0);
        top: 5.3rem;
      }

      i {
        display: flex;
        height: 2.35em;
        width: 2.35em;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        cursor: pointer;
        transition: background-color 0.3s;

        &:hover {
          background-color: var(--hover-bg);
        }
      }
    }
  }

  .toggle-icon {
    left: 4%;
    right: unset !important;
    font-size: 1.5rem;
  }

  .info-container {
    height: inherit;
    width: inherit;
    border-radius: inherit;
    position: absolute;
    display: flex;
    flex-direction: column;
    color: var(--text-color);
    align-items: center;
    font-size: 1.1rem;
    padding: 5em 2.3em 2em;
    pointer-events: none;
    z-index: 6;
    left: 0;
    top: 0;

    .info-wrapper {
      opacity: 0;
      overflow: auto;
      transition: all 0.2s;
      padding: 0 2em 0 0;
      line-height: 1.7em;
      @include scrollbars();

      p {
        margin: 0;
        margin-bottom: 1.4em;
      }
    }
  }

  .playlist-container {
    height: inherit;
    width: inherit;
    border-radius: inherit;
    position: absolute;
    display: flex;
    flex-direction: column;
    color: var(--text-color);
    align-items: center;
    font-size: 2rem;
    padding: 3em 1em 1.5em;
    pointer-events: none;
    z-index: 6;
    left: 0;
    top: 0;

    .list-container {
      font-size: 1.3rem;
      overflow: auto;
      width: 100%;
      padding-right: 0.5em;
      @include scrollbars(4px);
      transition-delay: 0;
      opacity: 0;
      transition: all 0.2s;

      .list-item {
        display: flex;
        flex-direction: column;
        margin-bottom: 0.2em;
        cursor: pointer;
        transition: all 0.2s;
        padding: 0.8em 0.8em;
        border-radius: 0.3em;
        position: relative;

        &:hover {
          background-color: var(--hover-bg);
        }

        &.active {
          background-color: var(--active-bg);

          @keyframes loading-list {
            0% {
              background-position: 0 0;
            }
            100% {
              background-position: 4em 0;
            }
          }

          .loading {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-image: repeating-linear-gradient(
              -70deg,
              var(--audio-bar-loading-bg) 0% 30%,
              rgba(243, 156, 18, 0) 30% 68%,
              var(--audio-bar-loading-bg) 68% 100%
            );
            background-size: 4em 4em;

            z-index: 0;
            animation: loading-list 3s linear infinite;
            pointer-events: none;
          }
        }

        > div {
          z-index: 1;
        }

        .meta {
          display: flex;
          justify-content: space-between;
          font-size: 0.8em;
        }
      }
    }
  }

  .player-container {
    height: inherit;
    width: inherit;
    border-radius: inherit;

    display: flex;
    flex-direction: column;
    color: var(--text-color);
    align-items: center;
    font-size: 2rem;
    padding: 1.5em 0.5em 2.4em 0.5em;

    .title {
      font-size: 0.8em;
      font-weight: bold;
      white-space: nowrap;
      text-transform: capitalize;
    }

    .author {
      font-size: 0.5em;
      text-align: center;
      text-transform: capitalize;
    }

    .cover-wrapper {
      position: relative;
      height: 7em;
      width: 7em;
      margin: 1.2em 0;

      #spectrum {
        height: 120%;
        width: 120%;
        border-radius: 50%;

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        polygon {
          stroke: var(--spectrum-color);
          stroke-width: 0.1em;
          fill: transparent;
        }
      }

      .cover {
        overflow: hidden;
        height: 100%;
        width: 100%;
        border-radius: 50%;

        flex-shrink: 0;

        img {
          max-width: 100%;
          height: 100%;
          filter: sepia(0.5) saturate(2);
          transition: all 0.2s;
        }
      }
    }

    .chapter {
      margin-bottom: 1em;
      font-size: 0.7em;
    }

    .audio-bar-wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;

      .audio-bar-container {
        position: relative;
        padding: 0.2rem 0;

        &:hover .handle {
          transform: translate(-50%, -50%) scale(1);
        }

        .bar {
          width: 100%;
          height: 0.1em;
          background-color: var(--audio-bar-bg);
          border-radius: 0.3em;
          position: relative;

          @keyframes loading {
            0% {
              background-position: 0 0;
            }
            100% {
              background-position: 0.6em 0;
            }
          }

          .loading {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-image: repeating-linear-gradient(
              -55deg,
              var(--audio-bar-loading-bg) 0% 30%,
              rgba(243, 156, 18, 0) 30% 68%,
              var(--audio-bar-loading-bg) 68% 100%
            );

            background-size: 0.6em 0.4em;
            z-index: 5;
            animation: loading 1s linear infinite;
          }

          .played {
            position: absolute;
            z-index: 3;
            background-color: var(--audio-bar-played-bg);
            height: 100%;
            left: 0;
          }

          .buffered {
            background-color: var(--audio-bar-buffered-bg);
            display: inline-block;
            height: 100%;
            position: absolute;
            z-index: 2;
          }
        }

        .handle {
          height: 0.6em;
          width: 0.6em;
          border-radius: 50%;
          cursor: pointer;
          background-color: var(--audio-handle-bg);
          position: absolute;
          transform: translate(-50%, -50%) scale(0);
          top: 50%;
          // box-shadow: 0 0 0rem 0.2rem rgba(255, 255, 255, 0.2);
          z-index: 4;
          transition: transform 0.3s;
        }
      }

      .time-container {
        display: flex;
        justify-content: space-between;
        font-size: 0.5em;
        margin-top: 0.4em;
      }
    }

    .options {
      display: flex;
      font-size: 0.5em;
      justify-content: space-between;
      width: 90%;
      align-items: center;
      margin-bottom: 1em;

      div {
        cursor: pointer;
        transition: all 0.2s;
        border-radius: 50%;
        height: 3em;
        width: 3em;
        display: flex;
        justify-content: center;
        align-items: center;

        &.repeat {
          position: relative;

          & span {
            background-color: white;
            border-radius: 50%;
            font-size: 24px;
            color: black;
            padding: 2px 7px;
            transform: scale(0.4);
            position: absolute;
            right: -5px;
          }
        }

        &.repeat i {
          font-size: 1.5em;
        }

        &.shuffle i {
          font-size: 1.5em;
        }

        &.speed {
          font-size: 1.1em;
        }

        &.inactive {
          opacity: 0.3;
          cursor: default;
        }

        &.active {
          color: var(--active-color);
        }

        &:hover:not(.inactive) {
          background-color: var(--hover-bg);
        }
      }
    }

    .controls {
      display: flex;
      font-size: 0.5em;
      justify-content: space-between;
      width: 90%;
      align-items: center;

      img {
        height: 3.2em;
        width: 4.5em;
        border-radius: 3px;
        margin-bottom: 7px;
        cursor: pointer;
      }

      .prev,
      .next {
        z-index: 5;
        display: flex;
        justify-content: space-around;
        align-items: center;

        &.disabled {
          opacity: 0.2;
          cursor: default;
        }

        &:hover {
          background-color: rgba(white, 0.1);

          ~ .cover img {
            filter: sepia(0.5) saturate(2) blur(5px);
          }

          div {
            opacity: 1;

            &.disabled {
              opacity: 0.2;
              cursor: default;
            }
          }
        }

        div {
          border-radius: 50%;
          height: 20%;
          width: 20%;
          background-color: transp;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 1em;
          color: var(--text-color);
          cursor: pointer;
          transition: all 0.2s;
          font-size: 1.5em;

          opacity: 0;

          &:hover:not(.disabled) {
            background-color: var(--hover-bg);
          }
        }
      }

      .play-pause {
        font-size: 2em;
        height: 2em;
        width: 2em;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      div {
        cursor: pointer;
        transition: all 0.2s;
        border-radius: 50%;
        height: 3em;
        width: 3em;
        display: flex;
        justify-content: center;
        align-items: center;

        &.inactive {
          opacity: 0.3;
          cursor: default;
        }

        &:hover:not(.inactive) {
          background-color: var(--hover-bg);
        }
      }
    }
  }
}

#error-box {
  background-color: #f8d7da;
  padding: 1rem 2rem;
  border: 0.1rem solid #f5c6cb;
  position: absolute;
  bottom: 10%;
  width: 90%;
  left: 50%;
  border-radius: 0.4rem;
  transition: all 0.3s;
  transform: translate(-50%, 50%) scale(0);
  pointer-events: none;
  color: #721c24;
  font-weight: bold;

  &.show {
    transform: translate(-50%, 50%) scale(1);
  }
}
</style>
